import { Navigate, Outlet } from 'react-router-dom';
import { useAuthSession } from '../lib/auth';

export function ProtectedRoute() {
  const { user, loading } = useAuthSession();
  if (loading) return <div className="full-page-loader">…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return <Outlet />;
}
